module.exports = __webpack_public_path__ + "static/media/altcoin (1).201d0a4a.gif";